import React from 'react'
import {Button, Icon} from 'startlibs/lib/components'
import styled from 'styled-components'
import {getColor} from 'startlibs/lib/lib'
import {ServicesOfferingWrapper} from './CheckoutComponents'

const SuccessFeedback = styled.div `
  color: ${getColor('success')};
  font-size: 24px;
  display: flex;
  align-items: center;
  margin-bottom: 2rem;
  ${Icon} {
    border: 4px solid ${getColor('success')};
    width: 4rem;
    height: 4rem;
    line-height: 41px;
    text-align: center;
    display: inline-block;
    border-radius: 100px;
    margin-right: 1rem;
    font-size: 34px;
  }
  p {
    margin-bottom: 0;
    font-size: 14px;
    color: rgba(0,0,0,0.6);
  }
`
const AdditionalInstruction = styled.div `
  margin-bottom: 3rem;
  p {
    margin-bottom 0;
  }
`
const ManageSubscriptionButton = styled(Button.Link) `
  margin-bottom: 2rem;
`

class CheckoutSuccess extends React.PureComponent {

  render() {
    const {isStorageCheckout, title, finishButton, content, additional, orderPreview} = this.props
    return <div className="content edit-profile">
      <div className='profile-header checkout-header'>
        <h1>{title}</h1>
      </div>
      <SuccessFeedback>
        <Icon icon="check"/>
        {content}
      </SuccessFeedback>
      {additional}
      <div>
      </div>
      {orderPreview(null,true)}
      <ManageSubscriptionButton to="/billing" small outline>Manage Subscription</ManageSubscriptionButton>
      <hr/>
      <ServicesOfferingWrapper>
        {isStorageCheckout?
        <div className="card">
          <img src="/public/report-plan-220x220.png" alt="Plan Icon"/>
          <h4>Check out Horos Cloud Reporting and Sharing tools</h4>
          <p>Share studies and create reports with your Horos Cloud subscription!<br/>Select a plan that best fits your study needs.</p>
          <Button.Link highlight to="/checkout">Check our plans</Button.Link><Button.a target="_blank" href="https://horosproject.org/horos-cloud-reporting/" outline>Learn more</Button.a>
        </div>
        :
        <div className="card">
          <img src="/public/storage-plan-220x220.png" alt="Plan Icon"/>
          <h4>Would you like to store and have access to your image studies using the cloud?</h4>
          <p>Securely store and easily access medical imaging studies in your Horos Cloud.<br/>You can access them when and where you need to.</p>
          <Button.Link highlight to="/storage/checkout">Check our plans</Button.Link><Button.a target="_blank" href="https://horosproject.org/cloud-access-pricing/" outline>Learn more</Button.a>
        </div>
        }
      </ServicesOfferingWrapper>
      {finishButton && <div className="profile-footer">
        {finishButton}
      </div>}
    </div>
  }

}

export const ReportCheckoutSuccess = (props) =>
  <CheckoutSuccess
    title="Horos Cloud subscription"
    content={<div>
      <div>You successfully subscribed to <b>{props.planName} plan</b></div>
      <p>Thank you for subscribing. {!props.isFreePlanSelected && "Check the details of your order below."}</p>
    </div>}
    {...props}
  />

export const StorageCheckoutSuccess = (props) =>
  <CheckoutSuccess
    title="Horos Access subscription"
    isStorageCheckout
    content={<div>
      <div>You successfully subscribed to <b>{props.planName} plan</b></div>
      <p>Thank you for subscribing. Check the details of your order below.</p>
    </div>}
    additional={<AdditionalInstruction>
      <p><b>We will contact you in 1 business day to start your cloud storage setup.</b></p>
      <p>If you need any additional informance or assistance, feel free to reach out to our <a className="link" href="mailto:support@horosproject.org">support team</a>.</p>
    </AdditionalInstruction>}
    {...props}
  />



// WEBPACK FOOTER //
// ./src/javascripts/checkout/CheckoutSuccess.jsx